import type { ColDef } from 'ag-grid-community';

type TypeProductNameRow = {
  productName: string;
};

const getDeliveryAgencyProductNamesColumnDefs = () => {
  const columnDefs: ColDef<TypeProductNameRow>[] = [
    {
      field: 'productName',
      headerName: '상품명',
      flex: 1,
      minWidth: 252,
      wrapText: true,
      autoHeight: true,
      cellStyle: {
        whiteSpace: 'normal',
      },
    },
  ];

  return { columnDefs };
};

export default getDeliveryAgencyProductNamesColumnDefs;
